import { makeStyles } from '@mui/styles';

const importAssetStyle = makeStyles(() => ({
    previewContainer: {
        display: 'flex',
        justifyContent: 'center',
    },
    previewUploadFileName: {
        marginTop: '6px',
        backgroundColor: '#18BC9B',
        color: 'white',
        width: 'auto',
    },
}));

export { importAssetStyle };
